import {
  MESSAGES_FAILURE,
  MESSAGES_LOADING,
  MESSAGES_SUCCESS,
} from './constants';
import { createReducer } from './utils';

const defaultState = {
  botMessages: {},
  errorMessage: null,
  loading: true,
};

// reducer

export const reducer = createReducer(defaultState, {
  [MESSAGES_SUCCESS]: handleMessagesSuccess,
  [MESSAGES_FAILURE]: handleMessagesFailure,
  [MESSAGES_LOADING]: handleMessagesLoading,
});

//tasks report
function handleMessagesLoading(state, action) {
  return {
    ...state,
    loading: true,
  };
}

function handleMessagesSuccess(state, { payload: { message } }) {
  return {
    ...state,
    loading: false,
    botMessages: message,
  };
}

function handleMessagesFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    botMessages: {},
    errorMessage: error,
  };
}

// actions

export function getBotMessages(languaje) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: MESSAGES_LOADING });
    const {
      stores: { currentStore },
    } = getState();

    try {
      const lang = (languaje || 'en').toLowerCase();
      const response = await dataSource.requestBotMessages({
        store: currentStore,
        languaje: lang,
      });

      // Store the full multi-language response. Language selection happens in each consumer.
      dispatch({ type: MESSAGES_SUCCESS, payload: { message: response } });
    } catch (error) {
      console.log('getBotMessages error', error);
      dispatch({ type: MESSAGES_FAILURE, payload: { error } });
    }
  };
}
